/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import Demographics from '../components/insights360/Demographics';
import * as quickReportsActions from '../actions/quickReportsActions';
import * as crosstabActions from '../actions/crosstabActions';
import * as insight360Actions from '../actions/insight360Actions';
import * as definitionActions from '../actions/definitionActions';
import * as preferencesActions from '../actions/preferencesActions';
import CommonStudySelector from '../components/common/CommonStudySelector';
import Attitudes from '../components/insights360/attitudes/Attitudes';
import PersonaHeader from '../components/insights360/personaHeaders/PersonaHeader';
import Profiles from '../components/insights360/profiles/Profiles';
import Brands from '../components/insights360/brands/Brands';
import Reports360 from '../components/insights360/reports/Reports360';
import PersonaCreator from '../components/insights360/personaCreator/PersonaCreator';
import PersonaCreatorMultiSegments from
  '../components/insights360/personaCreatorMultiSegments/PersonaCreatorMultiSegmentsContainer';
import ExplorerDeepDive from '../components/insights360/ExplorerDeepDive';
import clearBaseIcon from '../images/insight360/clear-field-icon_190-190-190.png';
// import settingsIcon from '../images/salescatalyst/configuration_icon_default.png';
import BrandCatalystConfigurationScreen from
  '../components/insights360/BrandCatalystConfiguration/BrandCatalystConfigurationScreen';
import InlineEdit from '../components/common/InlineEdit/InlineEdit';
import StudyFootnotes from '../components/common/StudyFootnotes/StudyFootnotes';
import editIconActive from '../images/insight360/edit-icon_active.png';
import SaveDefinitionLabelPopupScreen from '../components/common/SaveDefinitionLabelPopupScreen';
import NotableCharacter from '../components/insights360/personaCreatorNotableCharacter/NotableCharacter';
// import * as urls from '../actions/urlTypes';
import {
  pdfFormat,
  reportPdfFormat,
  validateSegmentScreenDisplay,
} from '../util/Insight360Utils';
import {
  INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
  INGSIGHT_360_ATTITUDE_REPORT_NAME,
  INGSIGHT_360_BRANDS_REPORT_NAME,
  INSIGHT_360_BRANDS_TOP_VALUE,
  INGSIGHT_360_MEDIA_REPORT_NAME,
  INSIGHT_360_MEDIA_TOP_VALUE,
  INGSIGHT_360_PROFILE_REPORT_NAME,
  INGSIGHT_360_HEADERINFO_REPORT_NAME,
  INSIGHT360_EXPLORE,
  INSIGHT360_REPORTS,
  INSIGHT360_PERSONA_CREATOR,
  UPDATE_FOR_DEFINITION_LABEL,
  SAMPLE_SIZE_RESTRICTION,
  INSIGHT_360_LABEL,
  BRANDCATALYST_EXPORT_REPORT,
  CHANGE_FILTER_FROM_BRANDS,
  CHANGE_FILTER_FROM_MEDIA,
  REACH_PERCENTAGE_CHANGED_EXPLORER,
  REACH_PERCENTAGE_CHANGED_CREATOR,
  INVALID_PERSONA_EXPRESSION_SELECTED,
  INVALID_BASE_EXPRESSION_SELECTED,
  SAVE_CREATOR_DEFINITION_LABEL,
  CREATE_BUTTON_CLICK,
  ADD_BUTTON_CLICK,
  EXPLORE_BUTTON_CLICK,
  SET_BASE_BUTTON_CLICK,
  RESET_BUTTON_CLICK,
  DEFINITION_HEADER_LENGTH,
  BRAND_CATALYST_DEFINITION_LENGTH_WARNING,
  INSIGHT_360_REDUCERS_BASE,
  // MRI_STUDY_NAME_FLAG,
  INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
  BRAND_CATALYST_FEATUREID,
  INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
  INSIGHT_360_PROFILE_MEDIA_BRAND_TOP_VALUE,
} from '../constants';
import Media from '../components/insights360/medias/Media';
import Modal from '../components/common/Modal/Modal';
import GenericButton from '../components/common/GenericButton';
import { toastError } from '../util/toastUtils';
import { exportFileTitle } from '../util/CommonUtils';
import PersonaCreatorClusterSettings from
  '../components/insights360/personaCreatorClusterSettings/PersonaCreatorClusterSettingsContainer';
import SmartSearch from '../components/common/SmartSearch/SmartSearch';

const modalWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};
const modalPersonaCreatorPopupStyle = {
  width: '60%',
  height: '40px',
  left: '20%',
  top: '20%',
};
const validateStudyResultModal = {
  width: '60%',
  height: '40px',
  left: '20%',
  top: '20%',
};

const deepDiveScreenStyle = {
  width: '86%',
  left: '15%',
  top: '0',
  bottom: '0',
  margin: '0',
  borderRadius: '0',
  animation: 'deepDiveAnimateLftToRgt 1s 1',
  WebkitAnimation: 'deepDiveAnimateLftToRgt 1s 1',
};

const modalSettingStyle = {
  width: '51%',
  height: '40px',
  left: '24%',
  top: '20%',
};

const modalConfigurationStyle = {
  width: '79%',
  left: '22%',
  top: '0',
  bottom: '0',
  margin: '0',
  borderRadius: '0',
  animation: 'animateLftToRgt 1s 1',
  WebkitAnimation: 'animateLftToRgt 1s 1',
};


class Insight360Content extends Component {
  constructor(props) {
    super(props);
    const insight360PersonaFilter = ['', '', ''];
    insight360PersonaFilter.filterIndex = -1;
    this.state = {
      insightSearchPersonasParams: {},
      segmentSummaryReportParams: {},
      attitudeLoaded: false,
      brandLoaded: false,
      mediaLoaded: false,
      demoLoaded: false,
      attitudeCreatorLoaded: false,
      brandCreatorLoaded: false,
      mediaCreatorLoaded: false,
      demoCreatorLoaded: false,
      demographics: [],
      insight360PersonaExpression:
        this.props.insight360PersonaExpression !== undefined
          ? this.props.insight360PersonaExpression
          : [],
      insight360PersonaFilter:
        this.props.insight360PersonaFilter !== undefined
          ? this.props.insight360PersonaFilter
          : insight360PersonaFilter,
      attitudes: [],
      brands: [],
      media: [],
      profileBrands: [],
      profileMedia: [],
      scrollStarted: false,
      scrollCreatorStarted: false,
      // error: {},
      headerSuccess: true,
      // profileLoaded: false,
      segmentsScreen:
        this.props.segmentsScreen !== undefined
          ? this.props.segmentsScreen
          : false,
      showClusterSettingsModal: false,
      tempBcStudyInfo: {},
      studyPersonaDataPoints: [],
      downloadInitiated: false,
      exploreBtnDisabled: true,
      createCreatorBtnDisabled: true,
      baseBtnDisabled: true,
      bcReportExport: false,
      isBaseInEditMode: false,
      baseLabelUpdateObject: {},
      insight360Base: this.props.insight360Base !== undefined ?
        this.props.insight360Base : undefined,
      baseLabelUpdateCallBack: '',
      popupCloseButtonClick: true,
      updateBaseFlag: true,
      bcReportAvailable: false,
      ssResetInputInfo: false,
      preferenceUpdate: false,
    };

    this.validateSegmentScreenDisplay = this._validateSegmentScreenDisplay.bind(
      this,
    );
    this.updatedSmartSearch = React.createRef();
  }

  componentDidMount() {
    const { smartSearchStudy, brandCatalystPrefenceFlag } = this.props;
    window.addEventListener('scroll', this.loadOnScroll, true);
    if (brandCatalystPrefenceFlag &&
      typeof (smartSearchStudy) !== 'undefined') {
      this.setSelectedBCStudy(smartSearchStudy, true);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.demographics) {
      this.setState({ demographics: [] });
    } else if (this.props.demographics !== nextProps.demographics) {
      this.setState({ demographics: nextProps.demographics });
      if (this.state.downloadInitiated) {
        setTimeout(() => {
          this.download(
            'heading',
            'Single',
            'wholePersonaPdf',
            'personaHeader',
          );
          this.setState({ downloadInitiated: false });
        }, 1000);
      }
    }

    if (!nextProps.insight360PersonaExpression) {
      this.setState({ insight360PersonaExpression: [] });
    } else if (
      this.props.insight360PersonaExpression !==
      nextProps.insight360PersonaExpression
    ) {
      this.setState({
        insight360PersonaExpression: nextProps.insight360PersonaExpression,
      });
    }

    if (!nextProps.attitudes) {
      this.setState({ attitudes: [] });
    } else if (this.props.attitudes !== nextProps.attitudes) {
      this.setState({ attitudes: nextProps.attitudes });
    }

    if (
      !_.isEqual(this.props.insight360PersonaFilter, nextProps.insight360PersonaFilter)
    ) {
      this.setState(
        { insight360PersonaFilter: nextProps.insight360PersonaFilter },
        () => this.updatePersonaDetailsAfterFilterChange(),
      );
    }

    if (!nextProps.brands) {
      this.setState({ brands: [] });
    } else if (this.props.brands !== nextProps.brands) {
      this.setState({ brands: nextProps.brands });
    }
    if (!nextProps.profileBrands) {
      this.setState({ profileBrands: [] });
    } else if (this.props.profileBrands !== nextProps.profileBrands) {
      this.setState({ profileBrands: nextProps.profileBrands });
    }
    if (!nextProps.profileMedia) {
      this.setState({ profileMedia: [] });
    } else if (this.props.profileMedia !== nextProps.profileMedia) {
      this.setState({ profileMedia: nextProps.profileMedia });
    }

    if (!nextProps.media) {
      this.setState({ media: [] });
    } else if (this.props.media !== nextProps.media) {
      this.setState({ media: nextProps.media });
    }

    if (this.state.selectedTab !== nextProps.selectedTab) {
      this.setState({ selectedTab: nextProps.selectedTab }, () =>
        this.initialCallsAfterPersonaHeader(),
      );
    }

    if (this.state.segmentsScreen !== nextProps.segmentsScreen) {
      this.setState({ segmentsScreen: nextProps.segmentsScreen });
    }

    if (this.props.deepDivePopupShow !== nextProps.deepDivePopupShow) {
      if (nextProps.deepDivePopupShow) {
        this.deepDiveScreen.show();
      }
    }

    if (this.props.insight360Base !== nextProps.insight360Base) {
      this.setState({ insight360Base: nextProps.insight360Base });
    }

    if (this.props.bcConfigPopupShow !== nextProps.bcConfigPopupShow) {
      if (nextProps.bcConfigPopupShow.show) {
        this.bcConfigurationScreen.show();
        this.setState({
          ssResetInputInfo: true,
        }, () => {
          this.setState({
            ssResetInputInfo: false,
          });
        });
      }
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({
          exploreBtnDisabled: false,
          createCreatorBtnDisabled: false,
          baseBtnDisabled: false,
        });
      } else {
        this.setState({
          exploreBtnDisabled: true,
          createCreatorBtnDisabled: true,
          baseBtnDisabled: true,
        });
      }
    }
    if (!this.props.brandCatalystPrefenceFlag && nextProps.brandCatalystPrefenceFlag) {
      this.setSelectedBCStudy(this.props.smartSearchStudy, true);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.loadOnScroll, true);
  }

  loadOnScroll = () => {
    if (this.props.selectedTab === INSIGHT360_EXPLORE) {
      const profileContent = document.getElementById('profile-content');
      const profileContentRect =
        profileContent !== undefined && profileContent !== null
          ? profileContent.getBoundingClientRect()
          : '';
      if (profileContentRect.bottom < profileContent.offsetHeight) {
        this.setState({ scrollStarted: true });
      } else {
        this.setState({ scrollStarted: false });
      }

      const profileElem = document.getElementById('profile-end');
      const attitudeElem = document.getElementById('attitude-end');
      const brandElem = document.getElementById('brand-end');
      const mediaElem = document.getElementById('media-end');

      const profileRect =
        profileElem !== undefined && profileElem !== null
          ? profileElem.getBoundingClientRect()
          : '';
      const isAtProfileEnd =
        profileRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        profileRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const attitudeRect =
        attitudeElem !== undefined && attitudeElem !== null
          ? attitudeElem.getBoundingClientRect()
          : '';
      const isAtAttitudeEnd =
        attitudeRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        attitudeRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const brandRect =
        brandElem !== undefined && brandElem !== null
          ? brandElem.getBoundingClientRect()
          : '';
      const isAtBrandEnd =
        brandRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        brandRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const mediaRect =
        mediaElem !== undefined && mediaElem !== null
          ? mediaElem.getBoundingClientRect()
          : '';
      const isAtMediaEnd =
        mediaRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        mediaRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);

      // User at the end of content. load more content
      if (isAtProfileEnd) {
        if (!this.state.attitudeLoaded) {
          this.getPersonaOnScroll(
            this.state.insightSearchPersonasParams,
            'attitude'
          );
        }
      }

      if (isAtAttitudeEnd) {
        if (!this.state.brandLoaded) {
          this.getPersonaOnScroll(
            this.state.insightSearchPersonasParams,
            'brand',
          );
        }
      }

      if (isAtBrandEnd) {
        if (!this.state.mediaLoaded) {
          this.getPersonaOnScroll(
            this.state.insightSearchPersonasParams,
            'media',
          );
        }
      }

      if (isAtMediaEnd) {
        if (!this.state.demoLoaded) {
          this.getPersonaOnScroll(
            this.state.insightSearchPersonasParams,
            'demo',
          );
        }
      }
    } else if (
      this.props.selectedTab === INSIGHT360_PERSONA_CREATOR &&
      this.state.segmentsScreen === false &&
      this.validateSegmentScreenDisplay()
    ) {
      const profileContent = document.getElementById('profile-creator-content');
      const profileContentRect =
        profileContent !== undefined && profileContent !== null
          ? profileContent.getBoundingClientRect()
          : '';
      if (profileContentRect.bottom < profileContent.offsetHeight) {
        this.setState({ scrollCreatorStarted: true });
      } else {
        this.setState({ scrollCreatorStarted: false });
      }

      const profileElem = document.getElementById('profile-creator-end');
      const attitudeElem = document.getElementById('attitude-creator-end');
      const brandElem = document.getElementById('brand-creator-end');
      const mediaElem = document.getElementById('media-creator-end');

      const profileRect =
        profileElem !== undefined && profileElem !== null
          ? profileElem.getBoundingClientRect()
          : '';
      const isAtProfileEnd =
        profileRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        profileRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const attitudeRect =
        attitudeElem !== undefined && attitudeElem !== null
          ? attitudeElem.getBoundingClientRect()
          : '';
      const isAtAttitudeEnd =
        attitudeRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        attitudeRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const brandRect =
        brandElem !== undefined && brandElem !== null
          ? brandElem.getBoundingClientRect()
          : '';
      const isAtBrandEnd =
        brandRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        brandRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const mediaRect =
        mediaElem !== undefined && mediaElem !== null
          ? mediaElem.getBoundingClientRect()
          : '';
      const isAtMediaEnd =
        mediaRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        mediaRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      const isPersonaCreator = true;
      if (
        _.isEmpty(this.state.segmentSummaryReportParams) &&
        this.props.personaCreator.segments.segments !== undefined
      ) {
        const personaLabels = this.props.personaCreator.segments.segments.map(
          e => e.title,
        );
        const personaExpressions = this.props.personaCreator.segments.segments.map(
          e => e.expression,
        );
        const segmentSummaryReportParams = {
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          personaLabels,
          personaExpressions,
        };
        this.setState({
          segmentSummaryReportParams,
        });
      }
      // User at the end of content. load more content
      if (isAtProfileEnd) {
        if (!this.state.attitudeCreatorLoaded) {
          this.props.insight360Actions.getInsight360Personas(
            this.state.segmentSummaryReportParams,
            INGSIGHT_360_ATTITUDE_REPORT_NAME,
            null,
            null,
            isPersonaCreator,
          );
          this.setState({ attitudeCreatorLoaded: true });
        }
      }

      if (isAtAttitudeEnd) {
        if (!this.state.brandCreatorLoaded) {
          this.setState({ brandCreatorLoaded: true });
        }
      }

      if (isAtBrandEnd) {
        if (!this.state.mediaCreatorLoaded) {
          this.setState({ mediaCreatorLoaded: true });
        }
      }

      if (isAtMediaEnd) {
        if (!this.state.demoCreatorLoaded) {
          this.props.insight360Actions.getInsight360Personas(
            this.state.segmentSummaryReportParams,
            INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
            null,
            null,
            isPersonaCreator,
          );
          this.setState({ demoCreatorLoaded: true });
        }
      }
    }
  };

  downloadAll = () => {
    if (this.props.selectedTab === INSIGHT360_EXPLORE) {
      if (
        (this.props.attitudes !== undefined
          ? this.props.attitudes.length
          : 0) === this.props.insight360PersonaExpression.length &&
        (this.props.demographics !== undefined
          ? this.props.demographics.length
          : 0) === this.props.insight360PersonaExpression.length
      ) {
        this.download('heading', 'Single', 'wholePersonaPdf', 'personaHeader');
      } else if (
          (this.props.attitudes !== undefined
            ? this.props.attitudes.length
            : 0) < this.props.insight360PersonaExpression.length ||
          (this.props.demographics !== undefined
            ? this.props.demographics.length
            : 0) < this.props.insight360PersonaExpression.length
        ) {
          if (
            (this.props.attitudes !== undefined
              ? this.props.attitudes.length
              : 0) < this.props.insight360PersonaExpression.length
          ) {
            const personaLabels = _.slice(
              _.clone(this.props.insight360PersonaLabel),
              this.props.attitudes !== undefined
                ? this.props.attitudes.length
                : 0,
              this.props.insight360PersonaLabel.length,
            );
            const personaExpressions = _.slice(
              _.clone(this.props.insight360PersonaExpression),
              this.props.attitudes !== undefined
                ? this.props.attitudes.length
                : 0,
              this.props.insight360PersonaExpression.length,
            );
            const insightSearchPersonasParams = {
              token: this.props.loginResponse.data.token,
              uid: this.props.loginResponse.data.uid,
              accountId: this.props.activeAccountId,
              personaLabels,
              personaExpressions,
            };
            this.props.insight360Actions
              .getInsight360Personas(
                insightSearchPersonasParams,
                INGSIGHT_360_ATTITUDE_REPORT_NAME,
              )
              .then(() => {
                if (
                  (this.props.demographics !== undefined
                    ? this.props.demographics.length
                    : 0) < this.props.insight360PersonaExpression.length
                ) {
                  const personaLabels = _.slice(
                    _.clone(this.props.insight360PersonaLabel),
                    this.props.demographics !== undefined
                      ? this.props.demographics.length
                      : 0,
                    this.props.insight360PersonaLabel.length,
                  );
                  const personaExpressions = _.slice(
                    _.clone(this.props.insight360PersonaExpression),
                    this.props.demographics !== undefined
                      ? this.props.demographics.length
                      : 0,
                    this.props.insight360PersonaExpression.length,
                  );
                  const insightSearchPersonasParams = {
                    token: this.props.loginResponse.data.token,
                    uid: this.props.loginResponse.data.uid,
                    accountId: this.props.activeAccountId,
                    personaLabels,
                    personaExpressions,
                  };
                  this.props.insight360Actions.getInsight360Personas(
                    insightSearchPersonasParams,
                    INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
                  );
                  this.setState({ demoLoaded: true });
                }

                this.setState({ downloadInitiated: true });
              });
            this.setState({ attitudeLoaded: true });
            this.setState({ brandLoaded: true });
            this.setState({ mediaLoaded: true });
          } else {
            if (
              (this.props.demographics !== undefined
                ? this.props.demographics.length
                : 0) < this.props.insight360PersonaExpression.length
            ) {
              const personaLabels = _.slice(
                _.clone(this.props.insight360PersonaLabel),
                this.props.demographics !== undefined
                  ? this.props.demographics.length
                  : 0,
                this.props.insight360PersonaLabel.length,
              );
              const personaExpressions = _.slice(
                _.clone(this.props.insight360PersonaExpression),
                this.props.demographics !== undefined
                  ? this.props.demographics.length
                  : 0,
                this.props.insight360PersonaExpression.length,
              );
              const insightSearchPersonasParams = {
                token: this.props.loginResponse.data.token,
                uid: this.props.loginResponse.data.uid,
                accountId: this.props.activeAccountId,
                personaLabels,
                personaExpressions,
              };
              this.props.insight360Actions.getInsight360Personas(
                insightSearchPersonasParams,
                INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
              );
              this.setState({ brandLoaded: true });
              this.setState({ mediaLoaded: true });
              this.setState({ demoLoaded: true });
            }

            this.setState({ downloadInitiated: true });
          }
        }
    } else if (this.props.selectedTab === INSIGHT360_REPORTS) {
      this.bcReportExportStatusFn(false);
    } else {
      // creator block
      const isPersonaCreator = true;
      if (
        !this.state.attitudeCreatorLoaded ||
        !this.state.brandCreatorLoaded ||
        !this.state.mediaCreatorLoaded ||
        !this.state.demoCreatorLoaded
      ) {
        if (!this.state.attitudeCreatorLoaded) {
          this.props.insight360Actions
            .getInsight360Personas(
              this.state.segmentSummaryReportParams,
              INGSIGHT_360_ATTITUDE_REPORT_NAME,
              null,
              null,
              isPersonaCreator,
            )
            .then(() => {
              this.setState({ attitudeCreatorLoaded: true });
              this.setState({ brandCreatorLoaded: true });
              this.setState({ mediaCreatorLoaded: true });
              this.props.insight360Actions
                .getInsight360Personas(
                  this.state.segmentSummaryReportParams,
                  INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
                  null,
                  null,
                  isPersonaCreator,
                )
                .then(() => {
                  this.setState({ demoCreatorLoaded: true });
                  this.download(
                    'heading',
                    'Single',
                    'wholePersonaPdf',
                    'personaHeader',
                  );
                });
            });
        } else {
          if (!this.state.brandCreatorLoaded) {
            this.setState({ brandCreatorLoaded: true });
          }

          if (!this.state.mediaCreatorLoaded) {
            this.setState({ mediaCreatorLoaded: true });
          }

          if (!this.state.demoCreatorLoaded) {
            this.props.insight360Actions
              .getInsight360Personas(
                this.state.segmentSummaryReportParams,
                INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
                null,
                null,
                isPersonaCreator,
              )
              .then(() => {
                this.setState({ demoCreatorLoaded: true });
                this.download(
                  'heading',
                  'Single',
                  'wholePersonaPdf',
                  'personaHeader',
                );
              });
          }
        }
      } else {
        this.download('heading', 'Single', 'wholePersonaPdf', 'personaHeader');
      }
    }
  };

  initialCallsForPersonaCreator = () => {
    if (
      this.props.selectedTab === INSIGHT360_PERSONA_CREATOR &&
      this.props.personaCreator !== undefined &&
      this.props.personaCreator.header !== undefined
    ) {
      const clusterSegmentsParam = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels: this.props.personaCreator.header.label,
        personaExpressions: this.props.personaCreator.header.expression,
      };

      this.props.insight360Actions
        .createClusterSegments(clusterSegmentsParam)
        .then(response => {
          if (response) {
            // this.notableCharacters();
            this.getPersonaCreatorProfilesData();
          }
        });
    }
  };

  // call for noteable characterstics..
  /* notableCharacters = () => {
    const token = this.props.loginResponse.data.token;
    const uid = this.props.loginResponse.data.uid;
    const accountId = this.props.activeAccountId;
    const personaLabels = this.props.personaCreator.header.label;
    const personaExpressions = this.props.personaCreator.header.expression;
    const top = 4;
    this.props.insight360Actions.
    getnotableCharacters(token, uid, accountId, personaLabels, personaExpressions,
      top);
  } */


  getPersonaCreatorProfilesData = isVpctUpdate => {
    // call profile/attitude/brand/media/demo
    if (
      this.props.personaCreator.segments !== undefined &&
      this.validateSegmentScreenDisplay()
    ) {
      const personaLabels = this.props.personaCreator.segments.segments.map(
        e => e.title,
      );
      const personaExpressions = this.props.personaCreator.segments.segments.map(
        e => e.expression,
      );
      const segmentSummaryReportParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
      };
      const isProfileBrandAndMedia = true;
      const isPersonaCreator = true;
      if (!isVpctUpdate) {
        this.props.insight360Actions.setSegmentScreen(false);
        // setting to false, as we are moving to profile screen of persona creator
        this.setState({
          segmentSummaryReportParams,
          attitudeCreatorLoaded: false,
          brandCreatorLoaded: false,
          mediaCreatorLoaded: false,
          demoCreatorLoaded: false,
        });
      }
      this.props.insight360Actions.getInsight360Personas(
        segmentSummaryReportParams,
        INGSIGHT_360_PROFILE_REPORT_NAME,
        null,
        null,
        isPersonaCreator,
      );
      // creator profile brand and media section
      this.props.insight360Actions.getInsight360Personas(
        segmentSummaryReportParams,
        INGSIGHT_360_BRANDS_REPORT_NAME,
        INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
        null,
        isPersonaCreator,
        null,
        isProfileBrandAndMedia,
      );
      this.props.insight360Actions.getInsight360Personas(
        segmentSummaryReportParams,
        INGSIGHT_360_MEDIA_REPORT_NAME,
        INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
        null,
        isPersonaCreator,
        null,
        isProfileBrandAndMedia,
      );
      // end creator profile brand and media section
      this.props.insight360Actions.getInsight360Personas(
        segmentSummaryReportParams,
        INGSIGHT_360_BRANDS_REPORT_NAME,
        INSIGHT_360_BRANDS_TOP_VALUE,
        null,
        isPersonaCreator,
      );
      this.props.insight360Actions.getInsight360Personas(
        segmentSummaryReportParams,
        INGSIGHT_360_MEDIA_REPORT_NAME,
        INSIGHT_360_MEDIA_TOP_VALUE,
        null,
        isPersonaCreator,
      );
      if (this.state.attitudeCreatorLoaded) {
        this.props.insight360Actions.getInsight360Personas(
          segmentSummaryReportParams,
          INGSIGHT_360_ATTITUDE_REPORT_NAME,
          null,
          null,
          isPersonaCreator,
        );
      }
      if (this.state.demoCreatorLoaded) {
        this.props.insight360Actions.getInsight360Personas(
          segmentSummaryReportParams,
          INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
          null,
          null,
          isPersonaCreator,
        );
      }
    }
  };

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    selectedReport: this.props.selectedReport,
    BaseDataGrid: this.props.BaseDataGrid,
    TargetDataGrid: this.props.TargetDataGrid,
    RecycleElements: this.props.recycleElements,
  });

  getInsight360Attitudes = () => {
    if (this.state.validExpression) {
      const reportName = '360ATT';
      const personaLabels = [this.state.tags.join(' ')];
      const personaExpressions = [this.state.expressionFormed.join(' ')];

      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        reportName,
        personaLabels,
        personaExpressions,
      };
      this.props.insight360Actions.getInsight360Personas(
        insightSearchPersonasParams,
      );
    }
  };

  getPersona = insightSearchPersonasParams => {
    if (this.props.selectedTab === INSIGHT360_EXPLORE) {
      const profileElem = document.getElementById('profile-end');
      const profileRect =
        profileElem !== undefined && profileElem !== null
          ? profileElem.getBoundingClientRect()
          : '';
      const isAtProfileEnd =
        profileRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        profileRect.right <=
        (window.innerWidth || document.documentElement.clientWidth);
      if (isAtProfileEnd) {
        if (!this.state.attitudeLoaded) {
          this.getPersonaOnScroll(insightSearchPersonasParams, 'attitude');
        }
      }
      if (this.state.headerSuccess === true) {
        this.setState({
          insightSearchPersonasParams,
          attitudeLoaded: false,
          brandLoaded: false,
          mediaLoaded: false,
          demoLoaded: false,
        });
        this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          INGSIGHT_360_PROFILE_REPORT_NAME,
        );
        this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          INGSIGHT_360_BRANDS_REPORT_NAME,
          INSIGHT_360_BRANDS_TOP_VALUE,
        );
        this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          INGSIGHT_360_MEDIA_REPORT_NAME,
          INSIGHT_360_MEDIA_TOP_VALUE,
        );
      }
    }
  };

  getPersonaOnScroll = (insightSearchPersonasParams, elem) => {
    if (this.props.selectedTab === INSIGHT360_EXPLORE) {
      const modifiedFilter = this.getModifiedFilter();
      if (elem === 'attitude') {
        if (
          (this.props.attitudes !== undefined
            ? this.props.attitudes.length
            : 0) < this.props.insight360PersonaExpression.length
        ) {
          const personaLabels = _.slice(
            this.props.insight360PersonaLabel,
            this.props.attitudes !== undefined
              ? this.props.attitudes.length
              : 0,
            this.props.insight360PersonaLabel.length,
          );
          const personaExpressions = _.slice(
            modifiedFilter,
            this.props.attitudes !== undefined
              ? this.props.attitudes.length
              : 0,
            modifiedFilter.length,
          );
          const insightSearchPersonasParams = {
            token: this.props.loginResponse.data.token,
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            personaLabels,
            personaExpressions,
          };
          this.props.insight360Actions.getInsight360Personas(
            insightSearchPersonasParams,
            INGSIGHT_360_ATTITUDE_REPORT_NAME,
          );
        }
        this.setState({ attitudeLoaded: true });
      } else if (elem === 'demo') {
        if (
          (this.props.demographics !== undefined
            ? this.props.demographics.length
            : 0) < this.props.insight360PersonaExpression.length
        ) {
          const personaLabels = _.slice(
            this.props.insight360PersonaLabel,
            this.props.demographics !== undefined
              ? this.props.demographics.length
              : 0,
            this.props.insight360PersonaLabel.length,
          );
          const personaExpressions = _.slice(
            modifiedFilter,
            this.props.demographics !== undefined
              ? this.props.demographics.length
              : 0,
            modifiedFilter.length,
          );
          const insightSearchPersonasParams = {
            token: this.props.loginResponse.data.token,
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            personaLabels,
            personaExpressions,
          };
          this.props.insight360Actions.getInsight360Personas(
            insightSearchPersonasParams,
            INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
          );
        }
        this.setState({ demoLoaded: true });
      } else if (elem === 'brand') {
        if (
          (this.props.brands !== undefined
            ? this.props.brands.length
            : 0) < this.props.insight360PersonaExpression.length
        ) {
          const personaLabels = _.slice(
            this.props.insight360PersonaLabel,
            this.props.brands !== undefined
              ? this.props.brands.length
              : 0,
            this.props.insight360PersonaLabel.length,
          );
          const personaExpressions = _.slice(
            modifiedFilter,
            this.props.brands !== undefined
              ? this.props.brands.length
              : 0,
            modifiedFilter.length,
          );
          const insightSearchPersonasParams = {
            token: this.props.loginResponse.data.token,
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            personaLabels,
            personaExpressions,
          };
          this.props.insight360Actions.getInsight360Personas(
        insightSearchPersonasParams,
        INGSIGHT_360_BRANDS_REPORT_NAME,
        INSIGHT_360_BRANDS_TOP_VALUE,
      );
        }
        this.setState({ brandLoaded: true });
      } else if (elem === 'media') {
        if (
          (this.props.media !== undefined
            ? this.props.media.length
            : 0) < this.props.insight360PersonaExpression.length
        ) {
          const personaLabels = _.slice(
            this.props.insight360PersonaLabel,
            this.props.media !== undefined
              ? this.props.media.length
              : 0,
            this.props.insight360PersonaLabel.length,
          );
          const personaExpressions = _.slice(
            modifiedFilter,
            this.props.media !== undefined
              ? this.props.media.length
              : 0,
            modifiedFilter.length,
          );
          const insightSearchPersonasParams = {
            token: this.props.loginResponse.data.token,
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            personaLabels,
            personaExpressions,
          };
          this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          INGSIGHT_360_MEDIA_REPORT_NAME,
          INSIGHT_360_MEDIA_TOP_VALUE,
        );
        }
        this.setState({ mediaLoaded: true });
      }
    }
  };

  loadAttitudeContent = () => {
    if (this.state.attitudeLoaded === false) {
      if (
        (this.props.attitudes !== undefined ? this.props.attitudes.length : 0) <
        this.props.insight360PersonaExpression.length
      ) {
        const modifiedFilter = this.getModifiedFilter();
        const personaLabels = _.slice(
          this.props.insight360PersonaLabel,
          this.props.attitudes !== undefined ? this.props.attitudes.length : 0,
          this.props.insight360PersonaLabel.length,
        );
        const personaExpressions = _.slice(
          modifiedFilter,
          this.props.attitudes !== undefined ? this.props.attitudes.length : 0,
          modifiedFilter.length,
        );
        const insightSearchPersonasParams = {
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          personaLabels,
          personaExpressions,
        };
        this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          INGSIGHT_360_ATTITUDE_REPORT_NAME,
        );
      }
      this.setState({ attitudeLoaded: true });
    }
  };

  download = (heading, filename, cardId, headerId) => {
    if (this.props.selectedTab === 'REPORTS') {
      filename = 'BrandCatalyst_Reporter';
    } else if (this.props.selectedTab === 'EXPLORE') {
      filename = 'BrandCatalyst_Persona';
    }  else if (this.props.selectedTab === 'CREATOR') {
      filename = 'BrandCatalyst_Creator';
    }

    // const pdfName = this.pdfFileNameFormat(filename);
    const pdfFileName = `${exportFileTitle(filename)}.pdf`;
    let downloadReport = [];
    const opt = {
      filename: pdfFileName,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape', dpi: 96 },
      hotfixes: [],
      pdfCallback: this.pdfCallback,
    };
    this.props.trackerFn({
      action: BRANDCATALYST_EXPORT_REPORT,
      attributes: { filename: pdfFileName },
    });
    if (this.props.selectedTab === 'REPORTS') {
      downloadReport = reportPdfFormat(headerId, cardId, this.props);
    } else {
      downloadReport = pdfFormat(headerId, cardId, this.props);
    }
    html2pdf()
      .from(downloadReport)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(() => { })
      .save();
  };

  pdfFileNameFormat = filename => {
    const currentDate = moment().format('YYYYMMDD');
    const currentTime = new moment().format('HHmmss');
    let pdfFileName = '';
    if (this.props.selectedTab === 'CREATOR') {
      if (filename === 'Single') {
        pdfFileName =
          `Simmons_Creator_${currentDate}_${currentTime}`;
      } else {
        pdfFileName =
          `Simmons_Creator_${filename}_${currentDate}_${currentTime}`;
      }
    }
    if (this.props.selectedTab === 'EXPLORE') {
      if (filename === 'Single') {
        pdfFileName = `Simmons_Persona_${currentDate}_${currentTime}`;
      } else {
        pdfFileName =
          `Simmons_${filename}_${currentDate}_${currentTime}`;
      }
    }
    if (this.props.selectedTab === 'REPORTS') {
      pdfFileName =
        `Simmons_${filename}_${currentDate}_${currentTime}`;
    }

    return pdfFileName;
  };

  setHeaderInfo = (headerInfo, selectedTab) => {
    this.trackerExpression = headerInfo.expression;
    const selectedTabInfo =
      selectedTab !== undefined ? selectedTab : this.props.selectedTab;
    this.props.insight360Actions
      .set360HeaderInfo(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        headerInfo,
        INGSIGHT_360_HEADERINFO_REPORT_NAME,
        selectedTabInfo,
      )
      .then(response => {
        if (typeof response !== 'undefined' && response.status === 400) {
          this.setState({ headerSuccess: false });
          this.props.trackerFn({
            action: INVALID_PERSONA_EXPRESSION_SELECTED,
            attributes: {
              newExpression: this.trackerExpression,
              currentExpression: this.props.insight360PersonaExpression,
              currentBase: this.props.insight360Base,
            },
          });
          toastError(response.data.message);
        } else {
          this.setState({ headerSuccess: true });
          if (selectedTabInfo === INSIGHT360_PERSONA_CREATOR) {
            this.initialCallsForPersonaCreator();
            if (this.props.pcWelcomePopup) {
              this.modalPersonaCreatorPopup.show();
              this.props.insight360Actions.setPersonaCreatorPopupDisplay(false);
            }
          } else {
            this.setState({ headerSuccess: true });
            this.initialCallsAfterPersonaHeader();
          }
        }
      })
      .catch(error => {
        console.warn(error);
      });
  };

  setBaseInfo = baseInfo => {
    if (
      (this.props.insight360Base === undefined && baseInfo !== undefined) ||
      (this.props.insight360Base !== undefined && baseInfo === undefined) ||
      (this.props.insight360Base !== undefined &&
        this.props.insight360Base.baseExpression !== baseInfo.baseExpression)
    ) {
      const isBaseCall = true;
      this.props.insight360Actions
        .validateBaseInfo(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          baseInfo,
          INGSIGHT_360_HEADERINFO_REPORT_NAME,
        )
        .then(response => {
          if (typeof response !== 'undefined' && response.status === 400) {
            this.setState({ headerSuccess: false });
            toastError(response.data.message);
          } else {
            const personaLabels = this.props.insight360PersonaLabel;
            const personaExpressions = this.getModifiedFilter();
            const insightSearchPersonasParams = {
              token: this.props.loginResponse.data.token,
              uid: this.props.loginResponse.data.uid,
              accountId: this.props.activeAccountId,
              personaLabels,
              personaExpressions,
            };
            if (personaExpressions && personaExpressions.length > 0) {
              this.props.insight360Actions
                .validateHeaderResponseValue(
                  insightSearchPersonasParams,
                  INGSIGHT_360_HEADERINFO_REPORT_NAME,
                  isBaseCall,
                  baseInfo,
                )
                .then(result => {
                  if (result) {
                    this.props.insight360Actions.set360Base(baseInfo);
                    this.baseExpressionChanged();
                  } else {
                    this.props.trackerFn({
                      action: INVALID_BASE_EXPRESSION_SELECTED,
                      attributes: {
                        newBase: baseInfo,
                        currentExpression: this.props.insight360PersonaExpression,
                      },
                    });
                  }
                });
            } else {
              this.props.insight360Actions.set360Base(baseInfo);
            }
          }
        })
        .catch(error => {
          console.warn(`error  ${error}`);
        });
    }
  };

  baseExpressionChanged = isVpctUpdate => {
    if (this.props.insight360PersonaExpression.length > 0) {
      const personaLabels = this.props.insight360PersonaLabel;
      const isProfileBrandAndMedia = true;
      const personaExpressions = this.getModifiedFilter();
      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
      };
      const isBaseCall = true;
      if (!isVpctUpdate) {
        this.props.insight360Actions.updateInsight360PersonasFilter(
          insightSearchPersonasParams,
          INGSIGHT_360_HEADERINFO_REPORT_NAME,
          isBaseCall,
        );
      }
      this.props.insight360Actions.updateInsight360PersonasFilter(
        insightSearchPersonasParams,
        INGSIGHT_360_PROFILE_REPORT_NAME,
        isBaseCall,
      );
      this.props.insight360Actions.updateInsight360PersonasFilter(
        insightSearchPersonasParams,
        INGSIGHT_360_BRANDS_REPORT_NAME,
        isBaseCall,
        INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
        null,
        isProfileBrandAndMedia,
      );
      this.props.insight360Actions.updateInsight360PersonasFilter(
        insightSearchPersonasParams,
        INGSIGHT_360_MEDIA_REPORT_NAME,
        isBaseCall,
        INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
        null,
        isProfileBrandAndMedia,
      );
      if (this.state.brands.length > 0) {
        this.props.insight360Actions.updateInsight360PersonasFilter(
          insightSearchPersonasParams,
          INGSIGHT_360_BRANDS_REPORT_NAME,
          isBaseCall,
          INSIGHT_360_BRANDS_TOP_VALUE,
        );
      }
      if (this.state.media.length > 0) {
        this.props.insight360Actions.updateInsight360PersonasFilter(
          insightSearchPersonasParams,
          INGSIGHT_360_MEDIA_REPORT_NAME,
          isBaseCall,
          INSIGHT_360_MEDIA_TOP_VALUE,
        );
      }
      if (this.state.attitudes.length > 0) {
        this.props.insight360Actions.updateInsight360PersonasFilter(
          insightSearchPersonasParams,
          INGSIGHT_360_ATTITUDE_REPORT_NAME,
          isBaseCall,
        );
      }
      if (this.state.demographics.length > 0) {
        this.props.insight360Actions.updateInsight360PersonasFilter(
          insightSearchPersonasParams,
          INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
          isBaseCall,
        );
      }
    }
  };

  filterExpressionChanged = (filter, indexOfDemographics) => {
    const element = filter[0];
    this.props.insight360Actions.set360DemographicsFilter({
      index: indexOfDemographics,
      filter: element,
    });
  };

  getPCSectionDataSortByReachAndIndex = reportName => {
    const isSectionSort = true;
    const isPersonaCreator = true;
    const isProfileBrandAndMedia = true;
    if (
      this.props.personaCreator.segments !== undefined &&
      this.validateSegmentScreenDisplay()
    ) {
      const personaLabels = this.props.personaCreator.segments.segments.map(
        e => e.title,
      );
      const personaExpressions = this.props.personaCreator.segments.segments.map(
        e => e.expression,
      );
      const segmentSummaryReportParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
      };
      if (reportName === '360BRANDS' || reportName === '360MEDIA') {
        this.props.insight360Actions.getInsight360Personas(
          segmentSummaryReportParams,
          reportName,
          INSIGHT_360_MEDIA_TOP_VALUE,
          null,
          isPersonaCreator,
          isSectionSort
        );
      } else {
        this.props.insight360Actions.getInsight360Personas(
          segmentSummaryReportParams,
          reportName,
          null,
          null,
          isPersonaCreator,
          isSectionSort
        );
        if (reportName === '360PROF') {
          this.props.insight360Actions.getInsight360Personas(
            segmentSummaryReportParams,
            INGSIGHT_360_BRANDS_REPORT_NAME,
            INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
            null,
            isPersonaCreator,
            isSectionSort,
            isProfileBrandAndMedia
          );
          this.props.insight360Actions.getInsight360Personas(
            segmentSummaryReportParams,
            INGSIGHT_360_MEDIA_REPORT_NAME,
            INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
            null,
            isPersonaCreator,
            isSectionSort,
            isProfileBrandAndMedia
          );
        }
      }
    }
  };

  sectionSortingByIndexAndReach = (reportName, sortByKey) => {
    let isPersonaCreator = null;
    const isProfileBrandAndMedia = true;
    // const modifiedFilter = this.getModifiedFilter();
    if (this.props.selectedTab === INSIGHT360_PERSONA_CREATOR) {
      isPersonaCreator = true;
    }
    const data = {
      reportName,
      sortByKey,
      isPersonaCreator,
    };
    this.props.insight360Actions.setSectionSortKey(data);
    const isSectionSort = true;
    if (this.props.selectedTab === INSIGHT360_EXPLORE) {
      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels: this.props.insight360PersonaLabel,
        personaExpressions: this.getModifiedFilter(),
      };

      if (reportName === '360BRANDS' || reportName === '360MEDIA') {
        this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          reportName,
          INSIGHT_360_MEDIA_TOP_VALUE,
          null,
          null,
          isSectionSort,
        );
      } else {
        this.props.insight360Actions.getInsight360Personas(
          insightSearchPersonasParams,
          reportName,
          null,
          null,
          null,
          isSectionSort,
        );
        if (reportName === '360PROF') {
          this.props.insight360Actions.getInsight360Personas(
            insightSearchPersonasParams,
            INGSIGHT_360_BRANDS_REPORT_NAME,
            INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
            null,
            null,
            isSectionSort,
            isProfileBrandAndMedia
          );
          this.props.insight360Actions.getInsight360Personas(
            insightSearchPersonasParams,
            INGSIGHT_360_MEDIA_REPORT_NAME,
            INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
            null,
            null,
            isSectionSort,
            isProfileBrandAndMedia
          );
        }
      }
    }
    if (this.props.selectedTab === INSIGHT360_PERSONA_CREATOR) {
      this.getPCSectionDataSortByReachAndIndex(reportName);
    }
  }

  getModifiedFilter = () => {
    const personaFilter = this.state.insight360PersonaFilter;
    const personaExpression = this.state.insight360PersonaExpression;
    const modifiedFilter = [];
    for (let i = 0; i < personaExpression.length; i += 1) {
      modifiedFilter.push(
        personaFilter[i] !== ''
          ? `(${personaExpression[i]}) AND (${personaFilter[i]})`
          : personaExpression[i],
      );
    }
    return modifiedFilter;
  };

  resetAll = () => {
    if (
      this.props.selectedTab === INSIGHT360_REPORTS ||
      this.props.selectedTab === INSIGHT360_EXPLORE
    ) {
      window.localStorage.setItem('brandCatalystBreadCrumb', '');
      if (
        (this.props.insight360PersonaLabel.length !== 0 &&
          this.props.insight360PersonaLabel !== undefined) ||
        this.props.insight360Base !== undefined
      ) {
        this.setState({
          attitudeLoaded: false,
          brandLoaded: false,
          mediaLoaded: false,
          demoLoaded: false,
          // error: {},
          // profileLoaded: false,
        });
        // Fire Action to delete all demographics
        this.modalWarining.show();
      }
    } else if (this.props.selectedTab === INSIGHT360_PERSONA_CREATOR) {
      this.modalWarining.show();
    }
  };

  resetPersonaData = () => {
    if (
      this.props.selectedTab === INSIGHT360_REPORTS ||
      this.props.selectedTab === INSIGHT360_EXPLORE
    ) {
      this.props.insight360Actions.resetAll();
    } else if (this.props.selectedTab === INSIGHT360_PERSONA_CREATOR) {
      this.props.insight360Actions.removePersonaCreator();
    }
  };

  removeDemographic = index => {
    // Fire Action to delete the right demographic
    this.props.insight360Actions.removeDemographic(index);
  };

  removePersonaCreator = () => {
    // Fire Action to delete the persona creator
    this.props.insight360Actions.removePersonaCreator();
  };

  updateAttitudeAgreeChoice = choice => {
    // Fire Action to update attitudes agree, disagree etc choice
    this.props.insight360Actions.updateAttitudeAgreeChoice(
      choice,
      this.props.selectedTab,
    );
  };

  handleClearBaseClick = () => {
    this.props.insight360Actions.set360Base(undefined);
    this.baseExpressionChanged();
  };

  toggleBaseEditMode = value => {
    this.setState({
      isBaseInEditMode: value,
    });
  };

  updateBaseHeaderLabel = (value, callback) => {
    const expression = [];
    const definationId = null;
    const expressionObj = {
      id: null,
      title: value.trimStart(),
      expression: this.state.insight360Base.baseExpression,
    };
    expression.push(expressionObj);

    const labelUpdateData = {
      defId: definationId,
      defName: '',
      expressions: expression,
    };
    this.setState({
      baseLabelUpdateObject: labelUpdateData,
      baseLabelUpdateCallBack: callback,
    });

    this.confirmationModal.show();
  };

  validateBaseHeaderLabel = (value, callback) => {
    // check the label max length equal to 64
    const callBackArg = value.length < DEFINITION_HEADER_LENGTH;
    if (callBackArg) {
      callback(true);
    } else {
      callback(false, BRAND_CATALYST_DEFINITION_LENGTH_WARNING);
    }
  };

  refreshDefinationdata = () => {
    this.props.definitionActions.getDefinitionTreeLoad(
      this.props.loginResponse.data.token,
      this.props.smartSearchStudy.ss === 'SIMMONS' ? 1 : 2,
      this.props.activeAccountId,
      this.props.smartSearchStudy.pn,
    );
  }


  onModalPopupXButtonClick = () => {
    if (this.state.popupCloseButtonClick) {
      this.state.baseLabelUpdateCallBack(false);
    } else {
      this.setState({
        popupCloseButtonClick: true,
      });
    }
  };


  onPersonaHeaderLabelSave = definationObject => {
    const mainCategory = INSIGHT_360_REDUCERS_BASE;
    const subCategory = undefined;
    const category = { mainCategory, subCategory };
    const headerLabelUpdateObject = _.clone(
      this.state.baseLabelUpdateObject,
    );

    if (
      definationObject.definitionFolderId !==
      headerLabelUpdateObject.defId
    ) {
      headerLabelUpdateObject.defId =
        definationObject.definitionFolderId;
      headerLabelUpdateObject.expressions[0].id = null;
    }
    headerLabelUpdateObject.defName =
      definationObject.definitionFolderName;

    this.props.insight360Actions.saveDefinitionData(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      this.props.smartSearchStudy.pn,
      headerLabelUpdateObject,
      this.state.baseLabelUpdateCallBack,
      this.refreshDefinationdata,
      undefined,
      category,
      this.state.updateBaseFlag,
    );
    this.setState(
      {
        popupCloseButtonClick: false,
      },
      () => {
        this.confirmationModal.hide();
      },
    );
  };

  //    updateBase = () => {
  //    this.props.ins
  //     insight360Base:
  // baseExpression: "FEMALE"
  // baseLabel: "FEMALE (ENDER)"
  //   }

  collapseDictionaryTree = () => {
    if (
      this.report360 !== undefined &&
      this.report360 !== null &&
      this.report360.refs !== undefined &&
      this.report360.refs.wrappedInstance !== undefined
    ) {
      this.report360.refs.wrappedInstance.collapseAll();
    }
  };

  updateSegmentsData = segmentsData => {
    this.props.insight360Actions
      .updatePersonaCreatorSegmentsData(segmentsData)
      .then(() => {
        this.getPersonaCreatorProfilesData();
      });
  };

  savePersonaCreatorDefLabel = (data, callbackFn) => {
    const saveDefLabelParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.smartSearchStudy.pn,
      data: {
        ...data,
        productNo: this.props.smartSearchStudy.pn,
      },
    };
    this.props.insight360Actions
      .saveUpdatedData(
        saveDefLabelParams.token,
        saveDefLabelParams.uid,
        saveDefLabelParams.accountId,
        saveDefLabelParams.data,
        UPDATE_FOR_DEFINITION_LABEL,
        callbackFn,
      )
      .then(response => {
        if (!response) {
          this.props.trackerFn({ action: SAVE_CREATOR_DEFINITION_LABEL });
        }
        this.props.definitionActions.getDefinitionTreeLoad(
          saveDefLabelParams.token,
          this.props.smartSearchStudy.ss === 'SIMMONS' ? 1 : 2,
          saveDefLabelParams.accountId,
          saveDefLabelParams.productNo,
        );
      });
  };

  applyVpctFilter = value => {
    const isPersonaCreator = this.props.selectedTab === INSIGHT360_PERSONA_CREATOR;
    const isVpctUpdate = true;
    this.props.insight360Actions
      .set360VerticalPercent(value, isPersonaCreator)
      .then(() => {
        if (isPersonaCreator) {
          this.props.trackerFn({ action: REACH_PERCENTAGE_CHANGED_CREATOR });
          this.getPersonaCreatorProfilesData(isVpctUpdate);
        } else {
          this.props.trackerFn({ action: REACH_PERCENTAGE_CHANGED_EXPLORER });
          this.baseExpressionChanged(isVpctUpdate);
        }
      });
  };

  clusterSettingsModalDisplay = newVal => {
    this.setState({ showClusterSettingsModal: newVal });
  };

  checkExplorerHasData = () => (
    this.props.insight360Base !== undefined ||
    (this.props.insight360PersonaExpression !== undefined &&
      this.props.insight360PersonaExpression.length > 0)
  );

  checkCreatorHasData = () => (
    this.props.personaCreator !== undefined &&
    this.props.personaCreator.header !== undefined &&
    this.props.personaCreator.header.expression !== undefined &&
    this.props.personaCreator.header.expression.length > 0
  );

  checkBCTabHasData = () => (
    this.checkExplorerHasData() || this.checkCreatorHasData()
  );

  setSelectedBCStudy = (studyInfo, prefUpdate) => {
    // this.props.insight360Actions.get360DemographicsFilter(
    //   this.props.loginResponse.data.token,
    //   this.props.insight360studyInfo.pn,
    // );
    const updatedStudy = {
      ...studyInfo,
      wt: 1,   // updating weight type to population by default.
    };
    if (this.props.selectedTab === 'CREATOR' && studyInfo.ss.includes('MRI')) {
      this.props.onselectedtab('EXPLORE');
    }
    this.setState({
      tempBcStudyInfo: updatedStudy,
    }, () => {
      let personaLabels = [];
      let personaExpressions = [];

      if (this.checkExplorerHasData()) {
        personaLabels = _.clone(this.props.insight360PersonaLabel);
        personaExpressions = _.clone(this.props.insight360PersonaExpression);
      }

      if (this.checkCreatorHasData()) {
        personaLabels.push(this.props.personaCreator.header.label);
        personaExpressions.push(this.props.personaCreator.header.expression);
      }

      if (this.props.insight360Base !== undefined) {
        personaLabels.push(this.props.insight360Base.baseLabel);
        personaExpressions.push(this.props.insight360Base.baseExpression);
      }

      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
        reportName: INGSIGHT_360_HEADERINFO_REPORT_NAME,
        productNo: this.state.tempBcStudyInfo.pn,
      };

      if (personaLabels.length > 0 && personaExpressions.length > 0) {
        this.props.insight360Actions
          .validateHeaderInfo(insightSearchPersonasParams)
          .then(response => {
            if (response === 400) {
              const tempPersonaData = insightSearchPersonasParams.personaExpressions.map(
                (expression, index) => ({
                  expression,
                  label: insightSearchPersonasParams.personaLabels[index],
                })
              );
              this.setState({
                studyPersonaDataPoints: tempPersonaData,
                preferenceUpdate: prefUpdate,
              });
              this.validateStudyResultModal.show();
            } else {
              this.applySelectedBCStudy('update');
            }
          });
      } else {
        this.applySelectedBCStudy();
      }
    });
    this.props.preferencesActions.setPreferenceFlag('brandCatalyst', false);
  };

  applySelectedBCStudy = method => {
    this.props.insight360Actions.set360Study(this.state.tempBcStudyInfo);
    this.setState({
      preferenceUpdate: false,
    });
    if (method === 'reset') {
      this.props.insight360Actions.removePersonaCreator();
      this.props.insight360Actions.resetAll();
    } else if (method === 'update') {
      if (this.checkExplorerHasData()) {
        this.baseExpressionChanged();
      }
      if (this.checkCreatorHasData()) {
        this.props.insight360Actions.removePersonaCreator();
      }
    }
  };

  getfilterSearchResult = (category, searchVal, callback) => {
    const insightFilterSearchParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      reportName:
        category === 'brands'
          ? INGSIGHT_360_BRANDS_REPORT_NAME
          : INGSIGHT_360_MEDIA_REPORT_NAME,
      searchText: searchVal,
    };
    this.props.insight360Actions
      .getCategorySearchList(insightFilterSearchParams)
      .then(response => {
        const responseData = [];
        if (response.length > 0) {
          response.forEach(data => {
            responseData.push({
              value: data.subCategory,
              label: data.categoryLabel,
            });
          });
          callback(responseData);
        } else {
          callback(responseData);
        }
      });
  };

  filterSearchApplyFn = (category, filters) => {
    if (category === 'brands') {
      this.props.trackerFn({ action: CHANGE_FILTER_FROM_BRANDS });
    } else {
      this.props.trackerFn({ action: CHANGE_FILTER_FROM_MEDIA });
    }
    this.props.insight360Actions.save360SelectedFilters(
      filters,
      category,
      this.props.selectedTab,
    );

    const reportName =
      category === 'brands'
        ? INGSIGHT_360_BRANDS_REPORT_NAME
        : INGSIGHT_360_MEDIA_REPORT_NAME;
    const topValue =
      category === 'brands'
        ? INSIGHT_360_BRANDS_TOP_VALUE
        : INSIGHT_360_MEDIA_TOP_VALUE;
    if (this.props.selectedTab === INSIGHT360_EXPLORE) {
      const personaLabels = this.props.insight360PersonaLabel;
      const personaExpressions = this.getModifiedFilter();
      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
      };
      const isBaseCall = true;
      this.props.insight360Actions.updateInsight360PersonasFilter(
        insightSearchPersonasParams,
        reportName,
        isBaseCall,
        topValue,
      );
      
    } else if (this.props.selectedTab === INSIGHT360_PERSONA_CREATOR) {
      const personaLabels = this.props.personaCreator.segments.segments.map(
        e => e.title,
      );
      const personaExpressions = this.props.personaCreator.segments.segments.map(
        e => e.expression,
      );
      const segmentSummaryReportParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
      };
      const isPersonaCreator = true;
      this.props.insight360Actions.getInsight360Personas(
        segmentSummaryReportParams,
        reportName,
        topValue,
        null,
        isPersonaCreator,
      );
     
    }
  };

  runInsight360Demographics = () => {
    const { validExpression, insight360_tags, definationTargetData,
      selectedCategoryRecType, expressionFormed, insight360PersonalLabels,
    } = this.updatedSmartSearch.current.state;
    this.updatedSmartSearch.current.handleSelectedIndexState();
    if (validExpression) {
      if (this.props.insight360PersonaExpression !== undefined &&
        this.props.insight360PersonaExpression.length > 0) {
        if (this.props.selectedTab === 'CREATOR') {
          this.props.trackerFn({ action: CREATE_BUTTON_CLICK });
        } else {
          this.props.trackerFn({ action: ADD_BUTTON_CLICK });
        }
      } else if (this.props.selectedTab === 'CREATOR') {
        this.props.trackerFn({ action: CREATE_BUTTON_CLICK });
      } else {
        this.props.trackerFn({ action: EXPLORE_BUTTON_CLICK });
      }
      const personaLabels = [insight360PersonalLabels.join(' ')];
      const personaExpressions = [expressionFormed.join(' ')];
      let personaExpressionsId = null;
      let definationId = null;
      if (selectedCategoryRecType === 'D') {
        const tagName = _.clone(insight360_tags);
        const object = _.clone(definationTargetData).find(
          obj => obj.title === tagName[0].trimStart(),
        );
        if (!_.isEmpty(object) && typeof object.expressionId !== 'undefined') {
          personaExpressionsId = object.expressionId;
          definationId = object.ovDefinitionId;
        }
      } else {
        personaExpressionsId = null;
        definationId = null;
      }

      this.setHeaderInfo({
        label: personaLabels,
        expression: personaExpressions,
        personaExpressionsId,
        definationId,
      });
      this.updatedSmartSearch.current.resetAll();
      this.props.crosstabActions.removeCrossTabKpiInfo();
    }
  };

  setInsight360Base = () => {
    const { expressionFormed, validExpression, insight360PersonalLabels,
    } = this.updatedSmartSearch.current.state;
    this.updatedSmartSearch.current.handleSelectedIndexState();
    this.props.trackerFn({ action: SET_BASE_BUTTON_CLICK });
    if (validExpression && this.props.insight360Base === undefined) {
      const baseLabel = insight360PersonalLabels.join(' ');
      const baseExpression = expressionFormed.join(' ');
      const baseInfo = {
        baseLabel,
        baseExpression,
      };
      this.setBaseInfo(baseInfo);
      this.updatedSmartSearch.current.resetAll();
      this.props.crosstabActions.removeCrossTabKpiInfo();
    }
  };

  runInsight360DemographicsReset = () => {
    this.props.trackerFn({ action: RESET_BUTTON_CLICK });
    this.resetAll();
  };

  showDeepDiveSlider = val => {
    this.props.insight360Actions.showDeepDivePopup(val);
  }

  renderClassForExplorer = () => {
    if (this.props.deepDivePopupShow) {
      return 'deep-dive-header';
    }
    if (this.state.scrollStarted === true) {
      return 'fixed-header';
    }
    return '';
  }

  renderClassForCreator = () => {
    if (this.props.deepDivePopupShow) {
      return 'deep-dive-header';
    }
    if (this.state.scrollCreatorStarted === true) {
      return 'fixed-header';
    }
    return '';
  }

  bcReportExportStatusFn = status => {
    this.setState({
      bcReportExport: status,
    }, () => (
      this.setState({
        bcReportExport: true,
      })
    ));
  }

  showBCConfigurations = flag => {
    this.props.insight360Actions.showBCCofigurationScreen(flag);
  }

  sourceDataInfo = className => (<StudyFootnotes
    studyList={this.props.studyList}
    selectedStudy={this.props.insight360studyInfo}
    className={className}
  />
  )

  _validateSegmentScreenDisplay() {
    if (
      this.props.personaCreator.segments.segments !== undefined &&
      this.props.personaCreator.segments.segments.length === 3
    ) {
      const segmentsData = _.filter(
        this.props.personaCreator.segments.segments,
        segment => parseInt(segment.sample, 10) >= SAMPLE_SIZE_RESTRICTION,
      );
      return segmentsData.length === 3;
    }
    return false;
  }

  updatePersonaDetailsAfterFilterChange() {
    if (
      this.props.insight360PersonaLabel.length > 0 &&
      this.state.insight360PersonaFilter.length > 0 &&
      this.state.insight360PersonaFilter.filterIndex > -1
    ) {
      const isProfileBrandAndMedia = true;
      const indexOfFilter = this.state.insight360PersonaFilter.filterIndex;
      const personaLabel = this.props.insight360PersonaLabel[indexOfFilter];
      const modifiedFilter = this.getModifiedFilter();
      const personaExpressions = [modifiedFilter[indexOfFilter]];
      const personaLabels = [personaLabel];
      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
        index: indexOfFilter,
      };
      const isBaseCall = false;
      this.props.insight360Actions
        .validateHeaderResponseValue(
          insightSearchPersonasParams,
          INGSIGHT_360_HEADERINFO_REPORT_NAME,
          isBaseCall,
        )
        .then(response => {
          if (response) {
            this.props.insight360Actions.updateInsight360PersonasFilter(
              insightSearchPersonasParams,
              INGSIGHT_360_PROFILE_REPORT_NAME,
              isBaseCall,
            );
            // .. profile media and brand call after filter changes
            if (
              this.state.profileBrands.length > 0 &&
              this.state.profileBrands[indexOfFilter] !== undefined
            ) {
              this.props.insight360Actions.updateInsight360PersonasFilter(
              insightSearchPersonasParams,
              INGSIGHT_360_BRANDS_REPORT_NAME,
              isBaseCall,
              INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
              null,
              isProfileBrandAndMedia,
            );
            }
            if (
              this.state.profileMedia.length > 0 &&
              this.state.profileMedia[indexOfFilter] !== undefined
            ) {
              this.props.insight360Actions.updateInsight360PersonasFilter(
              insightSearchPersonasParams,
              INGSIGHT_360_MEDIA_REPORT_NAME,
              isBaseCall,
              INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
              null,
              isProfileBrandAndMedia,
            );
            }
            // ending
            if (
              this.state.brands.length > 0 &&
              this.state.brands[indexOfFilter] !== undefined
            ) {
              this.props.insight360Actions.updateInsight360PersonasFilter(
              insightSearchPersonasParams,
              INGSIGHT_360_BRANDS_REPORT_NAME,
              isBaseCall,
              INSIGHT_360_BRANDS_TOP_VALUE,
            );
            }
            if (
              this.state.media.length > 0 &&
              this.state.media[indexOfFilter] !== undefined
            ) {
              this.props.insight360Actions.updateInsight360PersonasFilter(
              insightSearchPersonasParams,
              INGSIGHT_360_MEDIA_REPORT_NAME,
              isBaseCall,
              INSIGHT_360_MEDIA_TOP_VALUE,
            );
            }
            if (
              this.state.attitudes.length > 0 &&
              this.state.attitudes[indexOfFilter] !== undefined
            ) {
              this.props.insight360Actions.updateInsight360PersonasFilter(
                insightSearchPersonasParams,
                INGSIGHT_360_ATTITUDE_REPORT_NAME,
                isBaseCall,
              );
            }
            if (
              this.state.demographics.length > 0 &&
              this.state.demographics[indexOfFilter] !== undefined
            ) {
              this.props.insight360Actions.updateInsight360PersonasFilter(
                insightSearchPersonasParams,
                INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
                isBaseCall,
              );
            }
          } else {
            this.filterExpressionChanged([''], indexOfFilter);
            const newFilterArray = this.state.insight360PersonaFilter;
            newFilterArray.forEach(item => {
              if (item === indexOfFilter) {
                item = '';
              }
            });
            this.setState({ insight360PersonaFilter: newFilterArray });
          }
        });
    }
  }

  initialCallsAfterPersonaHeader() {
    const isProfileBrandAndMedia = true;
    if (
      this.props.selectedTab === INSIGHT360_EXPLORE &&
      (this.props.profiles !== undefined ? this.props.profiles.length : 0) <
      this.props.insight360PersonaExpression.length
    ) {
      const personaLabels = _.slice(
        _.clone(this.props.insight360PersonaLabel),
        this.props.profiles !== undefined ? this.props.profiles.length : 0,
        this.props.insight360PersonaLabel.length,
      );
      const personaExpressions = _.slice(
        _.clone(this.props.insight360PersonaExpression),
        this.props.profiles !== undefined ? this.props.profiles.length : 0,
        this.props.insight360PersonaExpression.length,
      );
      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels,
        personaExpressions,
      };
      this.setState({
        insightSearchPersonasParams,
        attitudeLoaded: false,
        brandLoaded: false,
        mediaLoaded: false,
        demoLoaded: false,
      });
      this.props.insight360Actions.getInsight360Personas(
        insightSearchPersonasParams,
        INGSIGHT_360_PROFILE_REPORT_NAME,
      );
      this.props.insight360Actions.getInsight360Personas(
        insightSearchPersonasParams,
        INGSIGHT_360_BRANDS_REPORT_NAME,
        INSIGHT_360_PROFILE_BRANDS_TOP_VALUE,
        null,
        null,
        null,
        isProfileBrandAndMedia,
      );
      this.props.insight360Actions.getInsight360Personas(
        insightSearchPersonasParams,
        INGSIGHT_360_MEDIA_REPORT_NAME,
        INSIGHT_360_PROFILE_MEDIA_TOP_VALUE,
        null,
        null,
        null,
        isProfileBrandAndMedia,
      );
    }
  }


  render() {
    const expressionPresent =
      this.props.personaCreator !== undefined &&
      this.props.personaCreator.header !== undefined &&
      this.props.personaCreator.header.expression !== undefined &&
      this.props.personaCreator.header.expression.length > 0;
    return (
      <div className="row fullWidth searchBar">
        <Modal
          title=""
          ref={node => {
            this.modalWarining = node;
            return this.modalWarining;
          }}
          dialogStyles={modalWariningStyle}
        >
          <div className="text-center">
            <p>This is going to delete all your selections</p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => {
                this.resetPersonaData();
                if (
                  this.report360 !== undefined &&
                  this.report360 !== null &&
                  this.report360.refs !== undefined &&
                  this.report360.refs.wrappedInstance !== undefined
                ) {
                  this.report360.refs.wrappedInstance.collapseAll();
                }
                this.modalWarining.hide();
              }}
            />
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => {
            this.confirmationModal = node;
            return this.confirmationModal;
          }}
          dialogStyles={modalSettingStyle}
          afterClose={this.onModalPopupXButtonClick}
        >
          <div className="text-center">
            <div className="">
              <SaveDefinitionLabelPopupScreen
                definitionTree={this.props.definitionTree}
                personaHeaderLabelUpdateObject={
                  this.state.baseLabelUpdateObject
                }
                onPersonaHeaderLabelSave={this.onPersonaHeaderLabelSave}
                productNo={this.props.smartSearchStudy.pn}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => {
            this.modalPersonaCreatorPopup = node;
            return this.modalPersonaCreatorPopup;
          }}
          dialogStyles={modalPersonaCreatorPopupStyle}
        >
          <div>
            <p className="text-center">Welcome to Persona Creator</p>
            <p className="text-center">
              Here you can cluster a persona using Simmons Attitudinal
              Statements to learn more about the segments that make up the
              persona.
            </p>
            <p>
              The default is set to 10 distinguishable variables Simmons
              selected as an example.
              <br />
              The default is set to create 3 clusters.
              <br />
              You can select any Simmons Attitudinal statements to cluster the
              persona.
              <br />
              You can create up to 9 clusters for a persona.
              <br />
              You can contiune on with the default and edit the settings later.
              <br />
              OR you can go directly to selecting the statements to cluster with
              and the number of clusters to generate.
            </p>
            <div className="text-center margin-top-15">
              <GenericButton
                name="Clustering Settings"
                btnStyle="i360-cmn-btn margin-right-5"
                onBtnClick={() => {
                  this.clusterSettingsModalDisplay(true);
                  this.modalPersonaCreatorPopup.hide();
                }}
              />
              <GenericButton
                name="Continue with default"
                btnStyle="i360-cmn-btn dark-btn"
                onBtnClick={() => {
                  this.modalPersonaCreatorPopup.hide();
                }}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => {
            this.bcConfigurationScreen = node;
            return this.bcConfigurationScreen;
          }}
          dialogStyles={modalConfigurationStyle}
          headerStyles={{ display: 'none' }}
          afterClose={() => this.showBCConfigurations(false)}
          isDragDisabled
          normalize
        >
          <BrandCatalystConfigurationScreen
            nodeRef={this.bcConfigurationScreen}
          />
        </Modal>
        {/* <Modal
          title=""
          ref={node => (this.modalSet360Study = node)}
          dialogStyles={modalWariningStyleNew}
          afterClose={() => this.setSelectedBCStudy('modalClose')}
        >
          <div
            className="large-12 medium-12 small-12 columns text-center"
            style={{ marginLeft: '-3%' }}
          >
            <div className="columns large-3 medium-3 small-3">
              <img
                className="i360-study-popup-alertIcon"
                id=""
                src={alertIcon}
                alt=""
              />
            </div>
            <div className="columns large-9 medium-9 small-9 i360-study-popup-msg">
              This selection will impact all of the Brand Catalyst modules
            </div>
            <div className="columns large-12 medium-12 small-12">
              <GenericButton
                name="Apply"
                btnStyle="button btn-cncl i360-study-popup-apply"
                onBtnClick={() => {
                  this.modalSet360Study.hide();
                  this.setSelectedBCStudy();
                }}
              />
              <GenericButton
                name="Cancel"
                btnStyle="button btn-cncl i360-study-popup-cancel"
                onBtnClick={() => {
                  this.modalSet360Study.hide();
                }}
              />
            </div>
          </div>
        </Modal> */}
        <Modal
          title="Validate Study Results"
          ref={node => {
            this.validateStudyResultModal = node;
            return this.validateStudyResultModal;
          }}
          dialogStyles={validateStudyResultModal}
          hideCloseButton
        >
          <div>
            <p>The following items are not available in the current study:</p>
            <p>
              <strong>
                Study Name: {this.state.tempBcStudyInfo.sd}
              </strong>
            </p>
            <div>
              <h3>Persona Data Points(s)</h3>
              <div className="bc-study-data-point margin-bottom-10">
                <ul>
                  {this.state.studyPersonaDataPoints.map(dataPoint => (
                    <li key={dataPoint.expression}>
                      {dataPoint.expression} - {dataPoint.label}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="text-right">
              {!this.state.preferenceUpdate && <GenericButton
                name="Cancel"
                btnStyle="button btn-cncl margin-right-10"
                onBtnClick={() => {
                  this.validateStudyResultModal.hide();
                  this.resetSelectedBCStudy();
                }}
              />}
              <GenericButton
                name="Ok"
                btnStyle="button btn-cncl"
                btnDisabled={this.state.activateApplyBtn}
                onBtnClick={() => {
                  this.applySelectedBCStudy('reset');
                  this.validateStudyResultModal.hide();
                }}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => {
            this.deepDiveScreen = node;
            return this.deepDiveScreen;
          }}
          dialogStyles={deepDiveScreenStyle}
          headerStyles={{ display: 'none' }}
          afterClose={() => this.showDeepDiveSlider(false)}
          isDragDisabled
          normalize
        >
          <ExplorerDeepDive
            nodeRef={this.deepDiveScreen}
            sourceDataInfo={this.sourceDataInfo}
          />
        </Modal>
        <div className="large-12 columns">
          <div className="row fullWidth">
            <div className="large-12">
              <div className="insight360-appBreadcrumb clearfix">
                {this.props.bcStudies !== undefined && (
                  <div className="left-heading">
                    <CommonStudySelector
                      studies={this.props.bcStudies}
                      featureID={BRAND_CATALYST_FEATUREID}
                      defaultStudy={this.props.smartSearchStudy}
                      dataOnScreen={this.checkBCTabHasData}
                      alertMsg="This selection will impact all of the Brand Catalyst modules"
                      setMethod={this.setSelectedBCStudy}
                      resetMethod={click => (this.resetSelectedBCStudy = click)}
                    />
                  </div>
                )}
                <p>
                  <span className="parent">Catalyst / </span>
                  {INSIGHT_360_LABEL}
                  {/*
                    // session settings is being removed for Brand Catalyst
                  (!this.props.universityUser) &&
                    <button className="margin-left-5" onClick={() => this.showBCConfigurations(true)}>
                      <img className="sc-icon-img" src={settingsIcon} alt="Settings" />
                    </button>
                  */}
                </p>
              </div>
              <div className="smart-search-editor">
                <SmartSearch
                  selectedModule="insight360"
                  moduleStudy={this.props.smartSearchStudy}
                  getSampleWeighted={
                    this.props.quickReportsActions.getSampleWeighted
                  }
                  fetchKPI={this.props.crosstabActions.fetchKPI}
                  removeKPI={this.props.crosstabActions.removeCrossTabKpiInfo}
                  gridData={this.getGridData()}
                  dataScreen="insight360"
                  selectedTab={this.props.selectedTab}
                  handleRemoveTags={this.collapseDictionaryTree}
                  trackerFn={this.props.trackerFn}
                  ref={this.updatedSmartSearch}
                  isTagInputExpanded
                  resetInputInfo={this.state.ssResetInputInfo}
                />
                <div className="insight360-moveto-wrapper">
                  {this.props.selectedTab !== 'CREATOR' ? <div className="insight360-button-group">
                    <GenericButton
                      name={
                        this.props.insight360PersonaExpression &&
                          this.props.insight360PersonaExpression.length > 0
                          ? 'ADD'
                          : 'EXPLORE'
                      }
                      btnStyle={this.state.exploreBtnDisabled ||
                        (this.props.insight360PersonaExpression !== undefined &&
                          this.props.insight360PersonaExpression.length === 3) ?
                        'i360-smart-search-button explore-btn' :
                        'i360-smart-search-button explore-btn active-btn'}
                      btnDisabled={this.state.exploreBtnDisabled ||
                        (this.props.insight360PersonaExpression !== undefined &&
                          this.props.insight360PersonaExpression.length === 3)}
                      onBtnClick={() => this.runInsight360Demographics()}
                    />
                    <GenericButton
                      name="Base"
                      btnStyle={this.state.baseBtnDisabled || (
                        this.props.insight360Base !== undefined &&
                        this.props.kpiInfo)
                        ? 'i360-smart-search-button base-btn'
                        : 'i360-smart-search-button active-btn base-btn'
                      }
                      onBtnClick={() => this.setInsight360Base()}
                      btnDisabled={this.state.baseBtnDisabled || (
                        this.props.insight360Base !== undefined &&
                        this.props.kpiInfo
                      )
                      }
                    />
                    {(this.props.insight360Base ||
                      (this.props.insight360PersonaExpression &&
                        this.props.insight360PersonaExpression.length > 0)) && (
                        <div className="display-inline-block">
                          <GenericButton
                            btnStyle="i360-smart-search-button active-btn reset-btn"
                            name="Reset"
                            onBtnClick={() => this.runInsight360DemographicsReset()}
                          />

                          {this.props.insight360PersonaExpression === undefined ||
                            (this.props.insight360PersonaExpression.length === 0 &&
                              this.props.insight360Base === undefined && (
                                <GenericButton
                                  btnStyle="i360-smart-search-button reset-btn"
                                  name="Reset"
                                />
                              ))}
                          {this.props.insight360PersonaExpression !== undefined &&
                            this.props.insight360PersonaExpression.length > 0 &&
                            (this.props.selectedTab !== 'REPORTS' || (this.props.selectedTab === 'REPORTS' &&
                              !_.isEmpty(this.props.report360SelectedCategory) && this.state.bcReportAvailable)) &&
                            (<div className="display-inline-block">
                              <GenericButton
                                btnStyle="i360-smart-search-button active-btn export-btn"
                                name="Export"
                                onBtnClick={() => this.downloadAll()}
                              />
                            </div>
                            )}
                        </div>
                      )}
                  </div> : <div className="insight360-button-group">
                      <GenericButton
                        name="Create"
                        btnStyle={this.state.createCreatorBtnDisabled || this.props.pcheaderData ?
                          'i360-smart-search-button create-btn' : 'i360-smart-search-button active-btn create-btn'}
                        btnDisabled={this.state.createCreatorBtnDisabled || this.props.pcheaderData}
                        onBtnClick={() => this.runInsight360Demographics()}
                      />
                      {expressionPresent && (
                        <GenericButton
                          btnStyle="i360-smart-search-button active-btn reset-btn"
                          name="Reset"
                          onBtnClick={() => this.runInsight360DemographicsReset()}
                        />
                      )}
                      {!expressionPresent && (
                        <GenericButton
                          btnStyle="i360-smart-search-button reset-btn"
                          btnDisabled
                          name="Reset"
                        />
                      )}

                      {this.props.totalSegmentsCount.length > 3 &&
                        this.props.pcheaderData &&
                        !this.props.segmentsScreen && (
                          <GenericButton
                            btnStyle="i360-smart-search-button active-btn segments-btn"
                            name="Segments"
                            onBtnClick={() => this.props.insight360Actions.setSegmentScreen(true)}
                          />
                        )}
                      {this.props.totalSegmentsCount.length > 3 &&
                        this.props.pcheaderData &&
                        this.props.segmentsScreen && (
                          <GenericButton
                            btnStyle="i360-smart-search-button segments-btn"
                            btnDisabled
                            name="Segments"
                          />
                        )}
                      {this.props.pcheaderData && (
                        <PersonaCreatorClusterSettings
                          showClusterSettingsModal={{
                            value: this.state.showClusterSettingsModal,
                            callback: () => this.clusterSettingsModalDisplay(false),
                          }}
                          getPersonaCreatorProfilesData={
                            this.getPersonaCreatorProfilesData
                          }
                          trackerFn={this.props.trackerFn}
                        />
                      )}
                      {expressionPresent &&
                        validateSegmentScreenDisplay(this.props.personaCreator) && (
                          <div className="display-inline-block">
                            <GenericButton
                              btnStyle="i360-smart-search-button active-btn export-btn"
                              name="Export"
                              onBtnClick={() => this.downloadAll()}
                            />
                          </div>
                        )}
                    </div>}
                </div>
              </div>
            </div>
          </div>
          {this.props.selectedTab === INSIGHT360_PERSONA_CREATOR && (
            <div>
              <div>
                  <div
                    id="persona-creator-content"
                    className={
                      this.renderClassForCreator()
                    }
                  >
                    <PersonaCreator
                      removePersonaCreator={this.removePersonaCreator}
                      segmentsScreen={this.state.segmentsScreen}
                      getPersonaCreatorProfilesData={
                        this.getPersonaCreatorProfilesData
                      }
                      savePersonaCreatorDefLabel={
                        this.savePersonaCreatorDefLabel
                      }
                      applyVpctFilter={this.applyVpctFilter}
                      trackerFn={this.props.trackerFn}
                      insight360studyInfo={this.props.insight360studyInfo}
                    />
                    <br />
                  </div>
                  <div>
                    {this.state.segmentsScreen === false && this.validateSegmentScreenDisplay() && (
                      <div>
                        <div id="profile-creator-content">
                          <NotableCharacter
                            segments={this.props.personaCreator.segments.segments || []}
                            sourceDataInfo={this.sourceDataInfo}
                          />
                        </div>
                        <br />
                        <div id="profile-creator-content">
                          <Profiles
                            download={this.download}
                            loadAttitudeContent={this.loadAttitudeContent}
                            profiles={this.props.personaCreator.profiles}
                            profileBrands={this.props.personaCreator.profileBrands}
                            medias={this.props.personaCreator.profileMedia}
                            endId="profile-creator-end"
                            sourceDataInfo={this.sourceDataInfo}
                            insight360studyInfo={this.props.insight360studyInfo}
                            sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                            selectedTab={this.props.selectedTab}
                          />
                        </div>
                        <br />
                        {this.state.attitudeCreatorLoaded === true && (
                          <Attitudes
                            updateAttitudeAgreeChoice={
                              this.updateAttitudeAgreeChoice
                            }
                            download={this.download}
                            insight360AttitudeAgreeChoice={
                              this.props.personaCreator
                                .insight360AttitudeAgreeChoice
                            }
                            attitudes={this.props.personaCreator.attitudes}
                            endId="attitude-creator-end"
                            studyName={this.props.insight360studyName}
                            sourceDataInfo={this.sourceDataInfo}
                            selectedTab={this.props.selectedTab}
                            insight360studyInfo={this.props.insight360studyInfo}
                            sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                          />
                        )}
                        <br />
                        {this.state.brandCreatorLoaded === true && (
                          <Brands
                            download={this.download}
                            brands={this.props.personaCreator.brands}
                            endId="brand-creator-end"
                            sourceDataInfo={this.sourceDataInfo}
                            getfilterSearchResult={this.getfilterSearchResult}
                            filterSearchApplyFn={this.filterSearchApplyFn}
                            selectedTab={this.props.selectedTab}
                            componentInfo={{ category: 'brands' }}
                            selectedFilters={
                              this.props.personaCreator.selectedFilters.brands
                            }
                            insight360studyInfo={this.props.insight360studyInfo}
                            sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                          />
                        )}
                        <br />
                        {this.state.mediaCreatorLoaded === true && (
                          <Media
                            download={this.download}
                            getfilterSearchResult={this.getfilterSearchResult}
                            filterSearchApplyFn={this.filterSearchApplyFn}
                            media={this.props.personaCreator.media}
                            endId="media-creator-end"
                            componentInfo={{ category: 'media' }}
                            sourceDataInfo={this.sourceDataInfo}
                            selectedTab={this.props.selectedTab}
                            selectedFilters={
                              this.props.personaCreator.selectedFilters.media
                            }
                            insight360studyInfo={this.props.insight360studyInfo}
                            sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                          />
                        )}
                        <br />
                        {this.state.demoCreatorLoaded === true && (
                          <Demographics
                            download={this.download}
                            demographics={
                              this.props.personaCreator.demographics
                            }
                            sourceDataInfo={this.sourceDataInfo}
                            selectedTab={this.props.selectedTab}
                            insight360studyInfo={this.props.insight360studyInfo}
                            sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                          />
                        )}
                        <br />
                      </div>
                    )}
                    {this.state.segmentsScreen === true && (
                      <PersonaCreatorMultiSegments
                        updateSegmentsData={this.updateSegmentsData}
                        disableSegmentScreen={() =>
                          this.props.insight360Actions.setSegmentScreen(false)
                        }
                      />
                    )}
                  </div>
                </div>
            </div>
          )}
          {this.props.selectedTab === INSIGHT360_REPORTS && (
            <Reports360
              filterExpressionChanged={this.filterExpressionChanged}
              baseExpressionChanged={this.baseExpressionChanged}
              removeReportPersona={this.removeDemographic}
              index={this.props}
              removeDemographic={this.removeDemographic}
              personaFilter={this.state.insight360PersonaFilter}
              isReports
              download={this.download}
              onselectedtab={this.props.onselectedtab}
              ref={report => {
                this.report360 = report;
                return this.report360;
              }}
              sourceDataInfo={this.sourceDataInfo}
              trackerFn={this.props.trackerFn}
              bcReportExport={this.state.bcReportExport}
              reportAvailable={status => this.setState({
                bcReportAvailable: status,
              })}
              insight360studyInfo={this.props.insight360studyInfo}
              selectedTab={this.props.selectedTab} 
            />
          )}
          {this.props.selectedTab === INSIGHT360_EXPLORE && (
            <div>
              {this.props.insight360Base !== undefined && (
                <div className="row fullWidth insight360-base">
                  {(this.state.insight360Base !== undefined &&
                    this.state.insight360Base.length !== 0) && (
                      <div className="padding-top-10 sc-wrap-base">
                        BASE:&nbsp;
                        <InlineEdit
                          textVal={this.props.insight360Base.baseLabel}
                          editBlockWidth="100%"
                          icon={editIconActive}
                          editFunction={this.toggleBaseEditMode}
                          updateFn={this.updateBaseHeaderLabel}
                          validateFn={this.validateBaseHeaderLabel}
                          editViewClass="sc-cmn-edit-block"
                        />
                        {!this.state.isBaseInEditMode && <img
                          className="i360_header_icons_img bc-base-remove-icon"
                          src={clearBaseIcon}
                          alt="Remove"
                          onClick={() => {
                            this.handleClearBaseClick();
                          }}
                        />}
                      </div>
                    )}
                </div>
              )}
              <div className="row fullWidth bc-header-section-gap">
                <span>&nbsp;</span>
              </div>
              <div
                id="persona-content"
                className={
                  this.renderClassForExplorer()
                }
              >
                <PersonaHeader
                    filterExpressionChanged={this.filterExpressionChanged}
                    removeDemographic={this.removeDemographic}
                    personaFilter={this.state.insight360PersonaFilter}
                    isReports={false}
                    applyVpctFilter={this.applyVpctFilter}
                    trackerFn={this.props.trackerFn}
                    insight360studyInfo={this.props.insight360studyInfo}
                  />
              </div>
              <div id="profile-content">
                <Profiles
                    download={this.download}
                    loadAttitudeContent={this.loadAttitudeContent}
                    profiles={this.props.profiles}
                    profileBrands={this.props.profileBrands}
                    medias={this.props.profileMedia}
                    endId="profile-end"
                    sourceDataInfo={this.sourceDataInfo}
                    insight360studyInfo={this.props.insight360studyInfo}
                    sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                    selectedTab={this.props.selectedTab}
                  />
              </div>
              <br />
              {this.state.attitudeLoaded === true && (
                <Attitudes
                  updateAttitudeAgreeChoice={this.updateAttitudeAgreeChoice}
                  download={this.download}
                  insight360AttitudeAgreeChoice={
                    this.props.insight360AttitudeAgreeChoice
                  }
                  attitudes={this.props.attitudes}
                  endId="attitude-end"
                  studyName={this.props.insight360studyName}
                  sourceDataInfo={this.sourceDataInfo}
                  selectedTab={this.props.selectedTab}
                  insight360studyInfo={this.props.insight360studyInfo}
                  sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                />
              )}
              <br />
              {this.state.brandLoaded === true && (
                <Brands
                  download={this.download}
                  brands={this.props.brands}
                  endId="brand-end"
                  sourceDataInfo={this.sourceDataInfo}
                  getfilterSearchResult={this.getfilterSearchResult}
                  filterSearchApplyFn={this.filterSearchApplyFn}
                  selectedTab={this.props.selectedTab}
                  componentInfo={{ category: 'brands' }}
                  selectedFilters={this.props.selectedFilters.brands}
                  insight360studyInfo={this.props.insight360studyInfo}
                  sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                />
              )}
              <br />
              {this.state.mediaLoaded === true && (
                <Media
                  download={this.download}
                  media={this.props.media}
                  data={this.props}
                  endId="media-end"
                  componentInfo={{ category: 'media' }}
                  indexOfFilter={this.state.insight360PersonaFilter.filterIndex}
                  sourceDataInfo={this.sourceDataInfo}
                  getfilterSearchResult={this.getfilterSearchResult}
                  filterSearchApplyFn={this.filterSearchApplyFn}
                  selectedTab={this.props.selectedTab}
                  selectedFilters={this.props.selectedFilters.media}
                  insight360studyInfo={this.props.insight360studyInfo}
                  sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                />
              )}
              <br />
              {this.state.demoLoaded === true && (
                <Demographics
                  download={this.download}
                  demographics={this.props.demographics}
                  sourceDataInfo={this.sourceDataInfo}
                  selectedTab={this.props.selectedTab}
                  insight360studyInfo={this.props.insight360studyInfo}
                  sectionSortingByIndexAndReach={this.sectionSortingByIndexAndReach}
                />
              )}
              <br />
            </div>
          )}
        </div>
      </div>
    );
  }
}

Insight360Content.propTypes = {
  // universityUser: PropTypes.bool,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  selectedTab: PropTypes.string,
  activeAccountId: PropTypes.number,
  quickReportsActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
  }),
  crosstabActions: PropTypes.shape({
    fetchKPI: PropTypes.func,
    removeCrossTabKpiInfo: PropTypes.func,
  }),
  kpiInfo: PropTypes.shape({
    intab: PropTypes.number,
  }),
  demographics: PropTypes.arrayOf(PropTypes.object),
  smartSearchStudy: PropTypes.shape({
    ss: PropTypes.string,
    pn: PropTypes.number,
  }),
  bcStudies: PropTypes.arrayOf(PropTypes.object),
  attitudes: PropTypes.arrayOf(PropTypes.object),
  insight360PersonaExpression: PropTypes.arrayOf(PropTypes.string),
  insight360PersonaLabel: PropTypes.arrayOf(PropTypes.string),
  insight360PersonaFilter: PropTypes.arrayOf(PropTypes.string),
  brands: PropTypes.arrayOf(PropTypes.object),
  insight360Base: PropTypes.shape({
    baseLabel: PropTypes.string,
    baseExpression: PropTypes.string,
  }),
  profiles: PropTypes.arrayOf(PropTypes.object),
  media: PropTypes.arrayOf(PropTypes.object),
  onselectedtab: PropTypes.func,
  removePersonaCreator: PropTypes.func,
  selectedFilters: PropTypes.shape({
    brands: PropTypes.instanceOf(Array),
    media: PropTypes.instanceOf(Array),
  }),
  insight360Actions: PropTypes.shape({
    getInsight360Personas: PropTypes.func,
    set360DemographicsFilter: PropTypes.func,
    createClusterSegments: PropTypes.func,
    validateBaseInfo: PropTypes.func,
    set360Base: PropTypes.func,
    set360VerticalPercent: PropTypes.func,
    validateHeaderInfo: PropTypes.func,
    removeDemographic: PropTypes.func,
    removePersonaCreator: PropTypes.func,
    updatePersonaCreatorSegmentsData: PropTypes.func,
    saveUpdatedData: PropTypes.func,
    updateAttitudeAgreeChoice: PropTypes.func,
    validateHeaderResponseValue: PropTypes.func,
    updateInsight360PersonasFilter: PropTypes.func,
    getCategorySearchList: PropTypes.func,
    setSegmentScreen: PropTypes.func,
    set360HeaderInfo: PropTypes.func,
    setPersonaCreatorPopupDisplay: PropTypes.func,
    resetAll: PropTypes.func,
    set360Study: PropTypes.func,
    save360SelectedFilters: PropTypes.func,
    showBCCofigurationScreen: PropTypes.func,
    saveDefinitionData: PropTypes.func,
    setSectionSortKey: PropTypes.func,
    showDeepDivePopup: PropTypes.func,
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
  }),
  trackerFn: PropTypes.func,
  deepDivePopupShow: PropTypes.bool,
  brandCatalystPrefenceFlag: PropTypes.bool,
  studyList: PropTypes.arrayOf(PropTypes.object),
  segmentsScreen: PropTypes.bool,
  profileBrands: PropTypes.instanceOf(Array),
  personaCreator: PropTypes.shape({
    media: PropTypes.instanceOf(Array),
    brands: PropTypes.instanceOf(Array),
    demographics: PropTypes.instanceOf(Array),
    attitudes: PropTypes.instanceOf(Array),
    profiles: PropTypes.instanceOf(Array),
    profileBrands: PropTypes.instanceOf(Array),
    profileMedia: PropTypes.instanceOf(Array),
    segments: PropTypes.instanceOf(Array),
    header: PropTypes.shape({
      label: PropTypes.string,
      expression: PropTypes.string,
    }),
    selectedFilters: PropTypes.shape({
      media: PropTypes.instanceOf(Array),
      brands: PropTypes.instanceOf(Array),
    }),
    insight360AttitudeAgreeChoice: PropTypes.string,
  }),
  insight360AttitudeAgreeChoice: PropTypes.string,
  insight360studyInfo: PropTypes.shape({}),
  preferencesActions: PropTypes.shape({
    setPreferenceFlag: PropTypes.func,
  }),
  pcWelcomePopup: PropTypes.bool,
  profileMedia: PropTypes.instanceOf(Array),
  totalSegmentsCount: PropTypes.instanceOf(Array),
  pcheaderData: PropTypes.bool,
  bcConfigPopupShow: PropTypes.shape({
    show: PropTypes.bool,
  }),
  definitionTree: PropTypes.instanceOf(Array),
  BaseDataGrid: PropTypes.instanceOf(Array),
  TargetDataGrid: PropTypes.instanceOf(Array),
  recycleElements: PropTypes.instanceOf(Array),
  selectedReport: PropTypes.string,
  insight360studyName: PropTypes.string,
  report360SelectedCategory: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    kpiInfo: state.crosstab.kpiInfo,
    demographics: state.insight360.demographics,
    attitudes: state.insight360.attitudes,
    insight360PersonaLabel: state.insight360.insight360PersonaLabel,
    insight360PersonaExpression: state.insight360.insight360PersonaExpression,
    insight360PersonaFilter: state.insight360.insight360PersonaFilter,
    brands: state.insight360.brands,
    insight360Base: state.insight360.insight360Base,
    profiles: state.insight360.profiles,
    media: state.insight360.media,
    error: state.insight360.error,
    personaCreator: state.insight360.personaCreator,
    insight360AttitudeAgreeChoice:
      state.insight360.insight360AttitudeAgreeChoice,
    segmentsScreen: state.insight360.personaCreator.segmentsScreen,
    pcWelcomePopup: state.insight360.personaCreator.pcWelcomePopup,
    pcheaderData: state.insight360.personaCreator.header,
    totalSegmentsCount:
      state.insight360.personaCreator.multiClusterSegments.segments || [],
    selectedFilters: state.insight360.selectedFilters,
    deepDivePopupShow: state.insight360.deepDivePopupShow,
    bcConfigPopupShow: state.insight360.bcConfiguration.bcConfigPopupShow,
    report360SelectedCategory: state.insight360.selectedCategory,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
    brandCatalystPrefenceFlag: state.preferences.preferenceFlags.brandCatalyst,
    // universityUser: state.login.loginResponse.data.universityUser || false,
    insight360studyName: state.study.insight360study.ss,
    insight360studyInfo: state.study.insight360study,
    studyList: state.study.insight360studies,
    profileBrands: state.insight360.profileBrands,
    profileMedia: state.insight360.profileMedia,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
    definitionActions: bindActionCreators(definitionActions, dispatch),
    preferencesActions: bindActionCreators(preferencesActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Insight360Content);
